import {JustificativaResumo} from '../types'
import JustificativasList from './JustificativasList'

interface Props {
    justificativas: JustificativaResumo[]
    loading: boolean
    onAbrir: (id: string) => void
    /** Retoma um RASCUNHO (entrevista salva pela metade) de onde parou. */
    onRetomar: (id: string) => void
    onVoltar: () => void
}

export default function HistoricoView({justificativas, loading, onAbrir, onRetomar, onVoltar}: Props) {
    return (
        <div>
            <header className="page-header">
                <div className="crumb">
                    <a onClick={onVoltar}>Ata Inteligente</a>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                    <span>Minhas Pesquisas</span>
                </div>
                <div className="header-row">
                    <h1 className="lg-h2">Minhas Pesquisas</h1>
                    <button className="lg-btn lg-btn--secondary lg-btn--sm" onClick={onVoltar}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
                        Nova busca
                    </button>
                </div>
                <p className="lg-text-muted" style={{marginBottom: 0}}>Justificativas de adesão e rascunhos da sua organização — retome os rascunhos de onde parou; abra as concluídas para revisar e baixar de novo.</p>
            </header>

            <div className="page-content">
                <JustificativasList
                    justificativas={justificativas} loading={loading}
                    onAbrir={onAbrir} onRetomar={onRetomar}
                />
            </div>
        </div>
    )
}
